/*
 * @Description: 策划中心路由
 * @Author: Bai.Zhiming
 * @LastEditors: pu.yuchun
 * @Date: 2017-11-9
 * @LastEditTime: 2019-10-30 22:39:27
 */
angular.module('planningCenterRouterModule', []).config([
    '$stateProvider',
    function($stateProvider) {
        $stateProvider
            .state('front.plan', {
                // 策划中心主路由
                url: '/plan',
                views: {
                    'main@front': {
                        templateUrl: './planningCenter/main_tpl.html',
                        controller: 'planningCenterCtrl'
                    },
                    'left@front.plan': {
                        templateUrl: './planningCenter/left/left_tpl.html',
                        controller: 'planningCenterLeft'
                    }
                }
            })
            .state('front.newplanning', {
                // 新策划中心主路由
                url: '/newplanning?url',
                views: {
                    'main@front': {
                        templateUrl: './planningCenter/newmain_tpl.html',
                        controller: 'planningCenterCtrl'
                    }
                }
            })
            .state('front.plan.realtimeclues', {
                // 策划中心实时线索主路由
                url: '/realtimeclues',
                views: {
                    'main@front.plan': {
                        template: "<div ui-view='main'></div>",
                        controller: 'realTimeCluesCtrl'
                    }
                }
            })
            .state('front.plan.command', {
                // 策划中心协同指挥
                url: '/command',
                views: {
                    'main@front.plan': {
                        template: "<div ui-view='main'></div>",
                        controller: 'commandCtrl'
                    }
                }
            })
            .state('front.plan.hotfocus', {
                url: '/hotfocus',
                views: {
                    'main@front.plan': {
                        template: "<div ui-view='main'></div>",
                        controller: 'hotFocusCtrl'
                    }
                }
            })
            .state('front.plan.rankinglist', {
                url: '/rankinglist',
                views: {
                    'main@front.plan': {
                        template: "<div ui-view='main'></div>",
                        controller: 'rankingListCtrl'
                    }
                }
            })
            .state('front.plan.eventanalysis', {
                url: '/eventanalysis',
                views: {
                    'main@front.plan': {
                        template: "<div ui-view='main'></div>",
                        controller: 'eventAnalysisCtrl'
                    }
                }
            })
            .state('front.plan.medialaboratory', {
                url: '/medialaboratory',
                views: {
                    'main@front.plan': {
                        template: "<div ui-view='main'></div>",
                        controller: 'mediaLaboratoryCtrl'
                    }
                }
            })
            .state('front.plan.taskassignment', {
                url: '/taskassignment',
                views: {
                    'main@front.plan': {
                        template: "<div ui-view='main'></div>",
                        controller: 'taskAssignmentCtrl'
                    }
                }
            });
    }
]);
